import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/produto.msg'

class EstoqueService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('estoque', msg)
  }
}

export default new EstoqueService()
